import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { useAuthStore } from './store/authStore';
import './styles/service.css';
import './styles/kds.css';
import '@matix/ui/login-styles';
import '@matix/ui/setup-styles';
// Side-effect import: stamps <html data-theme> from the stored choice or the OS
// preference before the first paint. Imported here, not only from the screens
// that toggle it, so the theme is settled even on the login route.
import './lib/theme';

// SSO handoff from the cashier's Kitchen Display button: #sso=<jwt>. Adopt it
// and strip it from the URL immediately, so the token is not left sitting in
// the address bar, in the back-history, or in whatever the tablet syncs.
const sso = window.location.hash.match(/[#&]sso=([^&]+)/);
if (sso?.[1]) {
  history.replaceState(null, '', window.location.pathname + window.location.search);
  useAuthStore.getState().adoptCashierToken(decodeURIComponent(sso[1]));
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
